import { error, success, warning } from 'react-notification-system-redux';

export const REDUCER_NAME = 'notice';

export const successAction = (options) => {
  const notificationOptions = {
    title: 'Notification',
    message: 'Saved with success!',
    position: 'tr'
  };
  return success({ ...notificationOptions, ...options });
};

export const warningAction = (options) => {
  const notificationOptions = {
    title: 'Notification',
    message: 'Warning',
    position: 'tr'
  };
  return warning({ ...notificationOptions, ...options });
};

export const errorAction = (options) => {
  const notificationOptions = {
    message: 'Oops, something went wrong...',
    position: 'tr'
  };
  return error({ ...notificationOptions, ...options });
};




// WEBPACK FOOTER //
// ./src/redux/modules/notifications.js